import React, { useState, useEffect } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useDispatch } from "react-redux";
import logo from "../../Assets/images/mainLogo.png";
import { setupAdminPassword } from "../../Redux/actions/userActions";
import classes from "./auth.module.css";
import { Button, Typography, Paper } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CloseEyeIcon, OpenEyeIcon } from "../../Components/Icons/Icons";
import AlertBox from "../../Components/AlertBox";

const SetupPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [alert, setAlert] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
      return value === password;
    });
    return () => {
      ValidatorForm.removeValidationRule("isPasswordMatch");
    };
  }, [password]);

  const handleSubmit = async () => {
    if (!token) {
      setAlert({ type: "error", message: "Invalid invite link. Please contact your administrator." });
      return;
    }
    const result = await dispatch(setupAdminPassword(token, password, confirmPassword));
    if (result.success) {
      setSubmitted(true);
    } else {
      setAlert({ type: "error", message: result.message });
    }
  };

  if (submitted) {
    return (
      <div className={classes.maindivForlogin}>
        <Paper className={classes.LoginPageMaindiv}>
          <div className={`col-lg-12 ${classes.LoinPageImageDiv}`}>
            <div className={`p-lg-5 p-4 ${classes.imageTextContainer}`}>
              <Typography className={classes.ImagePageMainHeader}>
                Welcome to Team Player
              </Typography>
              <Typography className={classes.ImagePageSubHeader}>
                Employee attendance management, location and time tracking application
              </Typography>
            </div>
          </div>
          <div className={classes.LoginPgeTextdiv}>
            <div className="p-lg-5 p-5">
              <span className="logo-lg mb-5">
                <img src={logo} alt="" height={50} />
              </span>
              <Typography className={classes.LoginPAgeMainHEader} style={{ marginTop: "30px" }}>
                Password Set
              </Typography>
              <Typography className="mt-2" style={{ marginTop: "10px", color: "#666" }}>
                Your password has been set successfully. You can now log in.
              </Typography>
              <Button
                variant="contained"
                fullWidth
                className={classes.LoginPageMainbtn}
                style={{ marginTop: "24px" }}
                onClick={() => navigate("/login")}
              >
                Go to Login
              </Button>
            </div>
          </div>
        </Paper>
      </div>
    );
  }

  return (
    <div className={classes.maindivForlogin}>
      <Paper className={classes.LoginPageMaindiv}>
        <div className={`col-lg-12 ${classes.LoinPageImageDiv}`}>
          <div className={`p-lg-5 p-4 ${classes.imageTextContainer}`}>
            <Typography className={classes.ImagePageMainHeader}>
              Welcome to Team Player
            </Typography>
            <Typography className={classes.ImagePageSubHeader}>
              Employee attendance management, location and time tracking application
            </Typography>
          </div>
        </div>
        <div className={classes.LoginPgeTextdiv}>
          <div className="p-lg-5 p-5">
            <div className="text-left">
              <span className="logo-lg mb-5">
                <img src={logo} alt="" height={50} />
              </span>
              <Typography className={classes.LoginPAgeMainHEader} style={{ marginTop: "30px" }}>
                Set Your Password
              </Typography>
              <Typography className="mt-2" style={{ marginTop: "10px", color: "#666" }}>
                Create a password to activate your TeamPlayer admin account.
              </Typography>
            </div>
            <ValidatorForm onSubmit={handleSubmit} useref="form" className={classes.LoginForm}>
              <div className="mt-4">
                <div>
                  <Typography className={`${classes.form_lable} mb-2`}>Password</Typography>
                  <div className={classes.passwordInputContainer}>
                    <TextValidator
                      sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, marginBottom: "15px" }}
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      placeholder="Enter password"
                      size="small"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      validators={["required", "minStringLength:8"]}
                      errorMessages={["Password is required", "Password must be at least 8 characters"]}
                    />
                    <div className={classes.showPassword}>
                      <Button variant="text" onClick={() => setShowPassword((v) => !v)}>
                        {showPassword ? <CloseEyeIcon /> : <OpenEyeIcon />}
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="mt-2">
                  <Typography className={`${classes.form_lable} mb-2`}>Confirm Password</Typography>
                  <div className={classes.passwordInputContainer}>
                    <TextValidator
                      sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, marginBottom: "15px" }}
                      type={showConfirm ? "text" : "password"}
                      fullWidth
                      placeholder="Confirm password"
                      size="small"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      validators={["required", "isPasswordMatch"]}
                      errorMessages={["Please confirm your password", "Passwords do not match"]}
                    />
                    <div className={classes.showPassword}>
                      <Button variant="text" onClick={() => setShowConfirm((v) => !v)}>
                        {showConfirm ? <CloseEyeIcon /> : <OpenEyeIcon />}
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="mt-2">
                  <Button variant="contained" fullWidth className={classes.LoginPageMainbtn} type="submit">
                    Set Password
                  </Button>
                </div>
              </div>
            </ValidatorForm>
          </div>
          {alert && (
            <AlertBox type={alert.type} message={alert.message} stateName={() => setAlert(null)} />
          )}
        </div>
      </Paper>
    </div>
  );
};

export default SetupPasswordPage;
